import { breakpoints, Card } from '@etg/wings';
import { useProperty, useSiteContext } from '@eti/providers';
import { m as motion, type HTMLMotionProps } from 'framer-motion';
import { useMediaQuery } from 'usehooks-ts';
import { getTransition } from './SearchFormCard.utils';

const SearchFormCard = ({ children, ...rest }: HTMLMotionProps<'div'>) => {
  const { brand } = useSiteContext();
  const { p } = useProperty();
  const milliSeconds = Number(p('StartPage.LoadSearchFormTimer.MilliSeconds')) || 0;
  const isWiderViewport = useMediaQuery(`(min-width: ${breakpoints._768})`);

  return (
    <motion.div
      animate={{ opacity: 1, transitionEnd: { pointerEvents: 'auto' } }}
      data-testid="fade-in-search-form-wrapper"
      initial={{ opacity: 0, pointerEvents: 'none' }}
      transition={getTransition({ brand, isWiderViewport, milliSeconds })}
      {...rest}
    >
      <Card padding={{ [breakpoints._0]: 16, [breakpoints._768]: 24 }}>{children}</Card>
    </motion.div>
  );
};

export default SearchFormCard;
